(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  exports.GeoJSON_Layer = (function(superClass) {
    extend(GeoJSON_Layer, superClass);

    function GeoJSON_Layer() {
      this.getGeometry = bind(this.getGeometry, this);
      this.applyLayerStyling = bind(this.applyLayerStyling, this);
      this.onSlider = bind(this.onSlider, this);
      GeoJSON_Layer.__super__.constructor.call(this);
      this.possibleAreaKeys = ['area', 'acres'];
      this.areaPropertyName = 'area';
      this.squareMetersToHectares = 0.0001;
      this.squareMetersToAcres = 0.000247105;
      this.layoutSelector = null;
      this.reposition_map = false;
      this.defaultOpacity = 70;
      this.useSlider = false;
      this.fetchUrl = null;
    }

    GeoJSON_Layer.prototype.beforeProcess = function(response, geojson) {
      return void 0;
    };

    GeoJSON_Layer.prototype.afterProcess = function(response, geojson) {
      return void 0;
    };

    GeoJSON_Layer.prototype.onSlider = function(ev, ui) {
      return this.setOpacity(ui.value);
    };

    GeoJSON_Layer.prototype.applyLayerStyling = function(geojson) {
      return this.layer = L.geoJson(this.flattenMultiPolygons(geojson), {
        style: (function(_this) {
          return function(ft) {
            var def, ref, ref1;
            def = {
              fillColor: "" + ((ref = ft.properties.fillColor) != null ? ref : "#00FF00"),
              color: "#000000",
              opacity: 0.75,
              fillOpacity: (ref1 = _this._fillOpacity) != null ? ref1 : 0.3,
              weight: 1
            };
            return $.extend(def, ft.mapProperties);
          };
        })(this),
        onEachFeature: (function(_this) {
          return function(ft, layer) {
            _this.addAreaProperty(ft);
            return _this.makeInfoWindow(ft, layer);
          };
        })(this)
      });
    };

    GeoJSON_Layer.prototype.init = function() {
      var self;
      self = this;
      if (this.useSlider) {
        this.initSlider();
        if (this.slider) {
          this.slider.on('slide', (function(_this) {
            return function(e, ui) {
              return _this.setOpacity(ui.value);
            };
          })(this));
        }
      }
      return this.loadReq = $.post(this.fetchUrl, this.loadLayoutPostOptions, (function(_this) {
        return function(response) {
          var geojson, result;
          geojson = _this.getGeometry(response);
          result = _this.beforeProcess(response, geojson);
          if (result !== 'skip') {
            _this.applyLayerStyling(geojson);
            _this.showLayer();
            _this.setOpacity(_this.defaultOpacity);
            return _this.afterProcess(response, geojson, _this.layer);
          }
        };
      })(this));
    };

    GeoJSON_Layer.prototype.getGeometry = function(response) {
      var ref;
      if (((ref = response.status) != null ? ref.type : void 0) === 'error') {
        App.addPopup('MissingFileDialog');
        this.destroy();
        return;
      }
      return $.parseJSON(response);
    };

    GeoJSON_Layer.prototype.makeInfoWindow = function(ft, layer) {
      var info, k, noshows, ref, v;
      noshows = ['bin', 'fillColor', 'binVal', 'BuPerAc', 'average_population', 'min', 'max', 'class', 'average'];
      if (ft.properties) {
        info = "<table class='table table-condensed margin-top-22'>";
        ref = ft.properties;
        for (k in ref) {
          v = ref[k];
          if (!(indexOf.call(noshows, k) >= 0) && this.hackit(k, ft.properties)) {
            info += "<tr><td><strong>" + k + "</strong></td><td>" + v + "</td></tr>";
          }
        }
        info += "</table>";
        return layer.bindPopup(info);
      }
    };

    GeoJSON_Layer.prototype.hackit = function(str, properties) {
      if (str === 'Population' && _.has(properties, 'Seed Population')) {
        return false;
      }
      return true;
    };

    GeoJSON_Layer.prototype.setOpacity = function(v) {
      var fill, line;
      fill = (v / 100).toFixed(2);
      line = ((v + 100) / 200).toFixed(2);
      if (this.layer != null) {
        this.layer.eachLayer(function(layer) {
          return layer.setStyle({
            fillOpacity: fill,
            opacity: line
          });
        });
      }
      this._opacity = v;
      this._fillOpacity = fill;
      return this._lineOpacity = line;
    };

    GeoJSON_Layer.prototype.hideLayer = function() {
      App.map.removeLayer(this.layer);
      if (this.useSlider && this.slider) {
        return this.slider.slider('disable');
      }
    };

    GeoJSON_Layer.prototype.showLayer = function() {
      App.map.addLayer(this.layer);
      if (this.reposition_map) {
        App.map.fitBounds(this.layer.getBounds());
      }
      if (this.useSlider && this.slider) {
        return this.slider.slider('enable');
      }
    };

    GeoJSON_Layer.prototype.refresh = function() {
      this.cleanUp();
      return GeoJSON_Layer.__super__.refresh.call(this);
    };

    GeoJSON_Layer.prototype.destroy = function() {
      this.cleanUp();
      return GeoJSON_Layer.__super__.destroy.call(this);
    };

    GeoJSON_Layer.prototype.cleanUp = function() {
      if (this.useSlider && this.slider) {
        this.slider.off('slide');
        this.slider.slider('disable');
      }
      if (this.loadReq != null) {
        this.loadReq.abort();
      }
      if (this.layer != null) {
        App.map.removeLayer(this.layer);
      }
      return typeof this.callback === "function" ? this.callback() : void 0;
    };

    GeoJSON_Layer.prototype.flattenMultiPolygons = function(geojson) {
      var feature, flatFeatures, flattened, flattenedFeature, i, index, j, key, l, len, len1, len2, possibleKey, ref, ref1, ref2, ref3, value;
      flatFeatures = [];
      if (!((function() {
        var i, len, ref, results;
        ref = geojson.features;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          feature = ref[i];
          if (feature.geometry.type.toLowerCase() === 'multipolygon') {
            results.push(feature);
          }
        }
        return results;
      })()).length) {
        return geojson;
      }
      ref = geojson.features;
      for (i = 0, len = ref.length; i < len; i++) {
        feature = ref[i];
        ref1 = feature.properties;
        for (key in ref1) {
          value = ref1[key];
          ref2 = this.possibleAreaKeys;
          for (j = 0, len1 = ref2.length; j < len1; j++) {
            possibleKey = ref2[j];
            if (_.includes(key.toLowerCase(), possibleKey)) {
              delete feature.properties[key];
            }
          }
        }
        if (feature.geometry.type.toLowerCase() === 'multipolygon') {
          flattened = turf.flatten(feature);
          ref3 = flattened.features;
          for (index = l = 0, len2 = ref3.length; l < len2; index = ++l) {
            flattenedFeature = ref3[index];
            flattened.features[index] = JSON.parse(JSON.stringify(flattenedFeature));
            if (feature.mapProperties) {
              flattened.features[index].mapProperties = feature.mapProperties;
            }
          }
          flatFeatures = flatFeatures.concat(flattened.features);
        } else {
          flatFeatures.push(feature);
        }
      }
      return turf.featureCollection(flatFeatures);
    };

    GeoJSON_Layer.prototype.addAreaProperty = function(feature) {
      var areaInSquareMeters, name, ref, value;
      ref = feature.properties;
      for (name in ref) {
        value = ref[name];
        if (_.includes(name.toLowerCase(), this.areaPropertyName.toLowerCase())) {
          return;
        }
      }
      areaInSquareMeters = turf.area(feature);
      if (App.is_metric) {
        return feature.properties['Area (ha)'] = _.round(areaInSquareMeters * this.squareMetersToHectares, 1);
      } else {
        return feature.properties['Area (ac)'] = _.round(areaInSquareMeters * this.squareMetersToAcres, 1);
      }
    };

    return GeoJSON_Layer;

  })(Handler);

}).call(this);
